import { memo } from "react";
import { Stack, Typography } from "@mui/material";
import { useTeleconsultoriaProfile } from "../../profile/TeleconsultoriaProfileContext";
import { useProvidedAffiliations } from "../hooks/useProvidedAffiliations";
import { AffiliationCard } from "./AffiliationCard";

/**
 * Pedidos recebidos ANTES de a clínica definir o papel: outras clínicas a
 * escolheram como prestadora. Aprovar o 1º pedido torna a clínica prestadora
 * (o perfil recarrega e a tela troca). Sem pedidos, não mostra nada.
 */
export const ReceivedAffiliationRequests = memo(function ReceivedAffiliationRequests() {
  const { rows, pendingRowId, setRowActive, answerRequest } = useProvidedAffiliations();
  const { reload: reloadProfile } = useTeleconsultoriaProfile();
  const requests = rows.filter((row) => row.isPendingRequest);

  if (!requests.length) return null;

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1" fontWeight={700}>
        Clínicas pedindo a sua teleconsultoria
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Ao aprovar, sua clínica passa a prestar teleconsultoria para elas.
      </Typography>
      <Stack spacing={1} role="list">
        {requests.map((row) => (
          <AffiliationCard
            key={row.id}
            row={row}
            isPending={pendingRowId === row.id}
            isDisabled={Boolean(pendingRowId)}
            onToggleActive={(target, isActive) => void setRowActive(target, isActive)}
            onAnswerRequest={(target, isApproved) =>
              void answerRequest(target, isApproved).then((isDone) => {
                if (isDone && isApproved) reloadProfile();
              })
            }
          />
        ))}
      </Stack>
    </Stack>
  );
});
